import { AdvancedMarker, InfoWindow } from '@vis.gl/react-google-maps';
import { pagesPath } from '@/lib/$path';
import { Route } from 'next';
import { service_ResponseForNonMemberPortalOfficeListing } from '@/init/swagger';
import { HospitalBuilding, ChevronRight } from 'mdi-material-ui';
import { Avatar, Box, Typography } from '@mui/material';
import { Link as MuiLink } from '@mui/material';
import { IbowOfficeChip } from '@/components/chip/IbowOfficeChip';
import { useLogic } from './logic';

type Props = {
  listing: service_ResponseForNonMemberPortalOfficeListing;
  hoveredMarkerListingId?: number | null;
  onMarkerClick?: (listingId: number) => void;
};

export const PublicStationMarker: React.FC<Props> = ({
  listing,
  hoveredMarkerListingId,
  onMarkerClick,
}) => {
  const {
    officeName,
    officeAddress,
    markerPosition,
    markerRef,
    marker,
    isIbowOffice,
    isShowInfoWindow,
    handleMarkerClick,
    handleMarkerMouseEnter,
    handleMarkerMouseLeave,
    isHovered,
    isTouchDevice,
  } = useLogic({
    listing,
    hoveredMarkerListingId,
    onMarkerClick,
  });

  return (
    <>
      <AdvancedMarker
        ref={markerRef}
        position={markerPosition}
        onClick={handleMarkerClick}
        zIndex={isHovered ? 1000 : undefined}
      >
        <Avatar
          sx={{
            background: '#33BEB9',
            border: 'solid 2px #FFFFFF',
            boxShadow: '6px 5px 5px -1px rgba(0, 0, 0, 0.4)',
            transform: isHovered ? 'scale(1.2)' : 'scale(1)',
            transition: 'transform 0.2s ease-in-out',
            cursor: 'pointer',
          }}
          onMouseEnter={!isTouchDevice ? handleMarkerMouseEnter : undefined}
          onMouseLeave={!isTouchDevice ? handleMarkerMouseLeave : undefined}
        >
          <HospitalBuilding sx={{ color: '#FFFFFF' }} />
        </Avatar>
      </AdvancedMarker>

      {isShowInfoWindow && (
        <InfoWindow
          anchor={marker}
          minWidth={320}
          maxWidth={320}
          headerDisabled
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {isIbowOffice && (
              <Box sx={{ pt: 1 }}>
                <IbowOfficeChip />
              </Box>
            )}

            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="JP/Heading/s/Bold/Tight" sx={{ flex: 1 }}>
                {officeName}
              </Typography>
            </Box>

            <Typography variant="JP/Body/m/Regular/Normal" color="#595960">
              {officeAddress}
            </Typography>

            <Box sx={{ py: 2 }}>
              <MuiLink
                href={
                  pagesPath.public.stations
                    ._portalOfficeId(listing.portal_office_id as number)
                    .$url().path as Route
                }
                underline="none"
                variant="JP/Body/s/Medium/None"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  color: '#33BEB9',
                  height: 24,
                  pl: 0,
                  py: 0.5,
                  gap: 0.5,
                  outline: 'none',
                }}
                target="_blank"
              >
                ステーション情報詳細へ
                <ChevronRight sx={{ width: 16, height: 16 }} />
              </MuiLink>
            </Box>
          </Box>
        </InfoWindow>
      )}
    </>
  );
};
